<template>
  <div id="app" v-bind:class="{ dark: darkmode }">
    <app-header :compact="false" :width="windowWidth"></app-header>
    <transition name="fade" mode="out-in">
      <router-view class="main" v-bind:class="{ dark: darkmode }"></router-view>
    </transition>
    <app-footer></app-footer>
  </div>
</template>

<script>
import AppHeader from '../common/Header'
import AppFooter from '../common/Footer'
export default {
  components: {
    AppHeader, AppFooter
  },
  data: () => {
    return {
      message: "",
      windowWidth: window.innerWidth,
    }
  },
  mounted() {
    window.onresize = () => {
      this.windowWidth = window.innerWidth
    }
  },
  computed: {
    darkmode() {
      return this.$store.state.darkmode
    },
  }
}
</script>
